module.exports = __webpack_public_path__ + "static/media/kapitalsparen_256832888.5ac9c4da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kapitalsparen_256832888.jpg
// module id = 341
// module chunks = 21